import ShowIfAnswersCount from './ShowIfAnswersCount';
export default ShowIfAnswersCount;



// WEBPACK FOOTER //
// ./src/components/ShowIfAnswersCount/index.js